import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ObjectUtils } from "src/app/utils/ObjectUtils";
import { environment } from "src/environments/environment";
import { AffiliateCreateDTO } from "../../schema/Billing/Affiliate/AffiliateCreateDTO";
import { AffiliateDTO } from "../../schema/Billing/Affiliate/AffiliateDTO";
import { AffiliateUpdateDTO } from "../../schema/Billing/Affiliate/AffiliateUpdateDTO";
import { AffiliatesFilterDTO } from "../../schema/Billing/Filter/AffiliatesFilterDTO";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";

@Injectable({
    providedIn: "root"
})
export class ApiAffiliateService {
    private relativePath: string;

    constructor(private http: HttpClient) {
        this.relativePath = `${environment.billing.url}/api/v1/Affiliates`;
    }

    public list(filterAffiliates: AffiliatesFilterDTO): Observable<GetDataDTO<AffiliateDTO>> {
        const httpParams = new HttpParams({
            fromObject: ObjectUtils.removeNullUndefinedFields(filterAffiliates)
        });

        return this.http.get<GetDataDTO<AffiliateDTO>>(`${this.relativePath}`, {
            params: httpParams
        });
    }

    public create(affiliate: AffiliateCreateDTO): Observable<AffiliateDTO> {
        return this.http.post<AffiliateDTO>(`${this.relativePath}`, affiliate);
    }

    public update(id: string, affiliate: AffiliateUpdateDTO): Observable<AffiliateDTO> {
        return this.http.put<AffiliateDTO>(`${this.relativePath}/${id}`, affiliate);
    }

    public getMain(subscriptionId?: string): Observable<AffiliateDTO> {
        const params = subscriptionId ? { subscriptionId } : {};
        return this.http.get<AffiliateDTO>(`${this.relativePath}/main`, { params });
    }

    public getById(id: string, subscriptionId?: string): Observable<AffiliateDTO> {
        const params = subscriptionId ? { subscriptionId } : {};
        return this.http.get<AffiliateDTO>(`${this.relativePath}/${id}`, { params });
    }
}
